import styled from 'styled-components';

export const Wrapper = styled.div({});

export const WrapperWithOverflow = styled.div({
  overflow: 'hidden',
});

export const ChildrenWrapper = styled.div({
  display: 'flex',
  outline: 'none',
});

export const ContentWrapper = styled.div({
  position: 'relative',
  height: 'fit-content',
  display: 'inline-block',
});
